import React, { useState } from "react";
import {
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  CardContent,
  Button,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PdfLayoutGuide from "./PdfLayoutGuide";
import * as pdfjsLib from "pdfjs-dist";
import RestorePageIcon from "@mui/icons-material/RestorePage";
// --------------------------------------
// VALIDATION
// --------------------------------------
const requiredNum = Yup.number()
  .required("Required")
  .min(0, "Cannot be negative");

const validationSchema = Yup.object({
  // HEADER
  headerY_mm: requiredNum,
  headerY_mmDec: requiredNum,

  // Doctor Info Toggle
  showDoctorInfo: Yup.string().required("Required"),

  // Doctor Info
  doctorInfo_xmm: Yup.number().when("showDoctorInfo", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),
  doctorInfo_xmmDec: Yup.number().when("showDoctorInfo", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),

  doctorInfo_ymm: Yup.number().when("showDoctorInfo", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),
  doctorInfo_ymmDec: Yup.number().when("showDoctorInfo", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),

  // Doctor Note Toggle
  showDoctorNote: Yup.string().required("Required"),

  // Doctor Note
  doctorNote_xmm: Yup.number().when("showDoctorNote", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),
  doctorNote_xmmDec: Yup.number().when("showDoctorNote", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),

  doctorNote_ymm: Yup.number().when("showDoctorNote", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),
  doctorNote_ymmDec: Yup.number().when("showDoctorNote", {
    is: "yes",
    then: (s) => s.required("Required"),
  }),
});

// --------------------------------------
// MAIN COMPONENT
// --------------------------------------
const AppointmentPdfSettings = ({ onSave }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfDimensions, setPdfDimensions] = useState({
    width: null,
    height: null,
  });

  const desiredImageWidth = 900; // px

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file || file.type !== "application/pdf") return;

    setLoading(true);
    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

      const page = await pdf.getPage(1);

      const viewport = page.getViewport({ scale: 1 });

      // REAL PDF dimensions (in rendering pixels)
      const pdfWidth = viewport.width;
      const pdfHeight = viewport.height;

      // SAVE them to state
      setPdfDimensions({ width: pdfWidth, height: pdfHeight });

      // create canvas same size
      const canvas = document.createElement("canvas");
      canvas.width = pdfWidth;
      canvas.height = pdfHeight;

      const ctx = canvas.getContext("2d");

      await page.render({ canvasContext: ctx, viewport }).promise;

      // convert canvas → PNG
      setImageSrc(canvas.toDataURL("image/png"));

      pdf.destroy();
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <CardContent>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <PdfLayoutGuide />
        </Grid>
      </Grid>
    </CardContent>
  );
};

export default AppointmentPdfSettings;
